import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import classNames from "classnames";
import { useCallback } from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ampli } from "../../../ampli";
import { getContractDetails } from "../../../setup/api/services/contract";
import { IContractDetailsResponseData } from "../../../setup/api/services/contract/models";
import { ROUTES } from "../../../setup/constants";
import { AuthConfig } from "../../../setup/context/config/authConfig";
import { CONTRACT_STATUS_AMPLI } from "../constants";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
// styles
import styles from "./styles.module.scss";

const AuthenticatedContractDetails = () => {
  const navigate = useNavigate();
  const userId = AuthConfig.getUserInfo().id;
  const { id } = useParams();
  const [contract, setContract] = useState<IContractDetailsResponseData>();
  const [loading, setLoading] = useState<boolean>(false);

  const sendAmpliEventViewedContractDetails = (
    contract: IContractDetailsResponseData
  ) => {
    ampli.viewedContractDetailsPage({
      contractStatus: CONTRACT_STATUS_AMPLI[contract.status],
      userRole: userId == contract.senderId ? "seller" : "buyer",
      contractId: contract.shortId,
    });
  };
  const fetchContractDetails = useCallback(
    (id: string) => {
      getContractDetails(id)
        .then((res) => {
          const data = res.data;
          if (
            userId == data.senderId ||
            (data.receiverId && userId == data?.receiverId) ||
            !data.receiverId
          ) {
            setContract(res.data);
            sendAmpliEventViewedContractDetails(res.data);
            setTimeout(() => setLoading(false), 500);
          } else navigate(ROUTES.CONTRACT_NOT_FOUND);
          setTimeout(() => setLoading(false), 500);
        })
        .catch(() => {
          navigate(ROUTES.CONTRACT_NOT_FOUND);
          setTimeout(() => setLoading(false), 500);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [navigate, userId]
  );

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        // Page is being loaded from bfcache (back-forward cache)
        window.location.reload();
      }
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/android/i.test(userAgent)) {
      window.location.replace(`waffyapp://www.waffy.com/contract/${id}`);
    }
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.location.replace(`waffyapp://www.waffy.com/contract/${id}`);
    }
  }, [id]);

  useEffect(() => {
    setLoading(true);
    if (id) fetchContractDetails(id);
  }, [fetchContractDetails, id]);

  const refreshContractDetails = () => {
    if (id) fetchContractDetails(id);
  };

  const back = () => {
    try {
      if (window?.history?.state) {
        navigate(-1);
      } else navigate(ROUTES.HOME);
    } catch (error) {
      navigate(ROUTES.HOME);
    }
  };

  if (loading) {
    return (
      <Box className={classNames(styles.container, styles.center)}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div className={classNames(styles["outter_container"])}>
      {contract && (
        <div className={styles["container"]}>
          <div className={classNames("card", styles["left_section"])}>
            <RightSection backHandler={back} contract={contract} />
          </div>
          <div className={classNames("card", styles["right_section"])}>
            <LeftSection
              contract={contract}
              refreshContractDetails={refreshContractDetails}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthenticatedContractDetails;
